module.exports = __webpack_public_path__ + "img/Transpordiamet_icon.55b8747c.svg";